import React, { useState, useEffect } from "react";
import { IonIcon, IonLabel, IonImg, IonModal, IonText, IonInput, isPlatform } from "@ionic/react";
import "../../global.scss";
import * as constants from "../../constants";
import PopUpVehicles from "../OnBoarding/PopUpVehicles";
import { checkMediaQuery } from "../../utils";
interface PageHeaderProps {
  mainHeader: string;
  navigation: any;
  showCars?: any;
  onClick: () => void;
  customStyle?: any;
}

const ConfirmPageHeading: React.FC<PageHeaderProps> = ({
  mainHeader,
  navigation,
  onClick,
  showCars,
  customStyle = {},
}: PageHeaderProps) => {
  const [showCarVehicles, setCarVehicles] = useState(false);
  const [carReg, setCarReg] = React.useState({
    model: "",
    reg: "",
  });
  React.useEffect(() => {
    if (navigation.onBoarding) {
      const data =
        navigation.userVehiclesList.length &&
        navigation.userVehiclesList.find(
          (ele: any) => ele.did === (navigation.selectedVehicleRef || "").split("/").pop(),
        );
      if (!!data) {
        setCarReg({
          model: data.model,
          reg: data.registrationNumber
            ? data.registrationNumber.slice(data.registrationNumber.length - 4)
            : "",
        });
      }
      setCarVehicles(false);
    }
  }, [navigation.userVehiclesList, navigation.selectedVehicleRef]);
  React.useEffect(() => {
    setCarVehicles(false);
  }, [navigation.selectedVehicleRef]);
  return (
    <div className="personal_details_div_child text_start" style={customStyle}>
      <div
        className={navigation.confirm ? "page-header-div confirm_search_div" : "page-header-div"}
      >
        <img
          src={checkMediaQuery() ? "/images/gray_backarrow.svg" : "/images/back_arrow.svg"}
          className="back_arrow"
          onClick={() => onClick()}
        />
        <IonLabel className="personal_details_labels" color="secondary">
          {mainHeader}
        </IonLabel>
      </div>
      {showCars && (
        <PopUpVehicles
          {...navigation}
          mainHeader={mainHeader}
          confirmScreen={true}
          closeConfirm={() => onClick()}
        />
      )}
    </div>
  );
};
export default ConfirmPageHeading;
